import { getOverviewRedesignFlag } from 'helpers/sesameCash.helpers';
import { useConfig } from 'hook/config.hook';
import { useSesameCash } from 'pages/SesameCashEnrollment/hooks/sesameCashHelper.hook';
import AccumulateSegmentCashPromotion from 'partial/OfferManager/modules/AccumulateSegmentCashPromotion';
import BoosterEnhancedCashSummary from 'partial/OfferManager/modules/BoosterEnhancedCashSummary';
import SesameCashModule from 'partial/OfferManager/modules/SesameCashModule/SesameCashModule';
import { useState } from 'react';
import { SESAME_CASH_BOOSTER_ENHANCED_1 } from 'types/sesameCash.constants';

const SesameCashSummaryView = props => {
  const { config } = useConfig();
  const {
    sesameCashAccount,
    sesameCashEnrolledView,
    sesameCashUnenrolledView,
    showFundAccountView,
    cashModuleVersion,
    showWebBoosterSignup,
    enhanceCashModules,
  } = useSesameCash(props.userInfo, config);

  const [visible, setVisible] = useState(false);

  const handleAccountOptionsClick = val => {
    setVisible(true);
  };

  if (showWebBoosterSignup) {
    if (cashModuleVersion === SESAME_CASH_BOOSTER_ENHANCED_1) {
      return (
        <BoosterEnhancedCashSummary
          {...props}
          cashModuleVersion={cashModuleVersion}
          sesameCashAccount={sesameCashAccount}
        />
      );
    } else if (enhanceCashModules) {
      return (
        <BoosterEnhancedCashSummary
          {...props}
          sesameCashAccount={sesameCashAccount}
        />
      );
    } else {
      return (
        <AccumulateSegmentCashPromotion
          {...props}
          sesameCashAccount={sesameCashAccount}
          isOverview={true}
        />
      );
    }
  } else if (cashModuleVersion === null && showFundAccountView) {
    if (enhanceCashModules) {
      return (
        <BoosterEnhancedCashSummary
          {...props}
          cashModuleVersion={cashModuleVersion}
          sesameCashAccount={sesameCashAccount}
        />
      );
    } else {
      return (
        <AccumulateSegmentCashPromotion
          {...props}
          sesameCashAccount={sesameCashAccount}
          isOverview={true}
        />
      );
    }
  } else {
    return (
      <>
        <SesameCashModule
          isOverviewPage={true}
          sesameCashAccount={sesameCashAccount}
          sesameCashEnrolledView={sesameCashEnrolledView}
          sesameCashUnenrolledView={sesameCashUnenrolledView}
          modulePosition={props.modulePosition}
          config={config}
          visible={visible}
          setVisible={setVisible}
          handleAccountOptionsClick={handleAccountOptionsClick}
          cashModuleVersion={cashModuleVersion}
          showWebBoosterSignup={showWebBoosterSignup}
          enhanceCashModules={enhanceCashModules}
          overviewRedesignFlag={getOverviewRedesignFlag()} // It should be replaced by optimizely flag on EPOD-2048
          {...props}
        />
        {/* hidden for exp CASH_BALANCE_HIGHER  */}
      </>
    );
  }
};

export default SesameCashSummaryView;
